import React from "react";

interface UpgradeFeatureItemProps {
  icon: React.ReactNode;
  title: string;
  description: string;
}

const UpgradeFeatureItem: React.FC<UpgradeFeatureItemProps> = ({
  icon,
  title,
  description,
}) => (
  <div className="flex items-start gap-2 sm:gap-2.5 bg-white rounded-md sm:rounded-lg p-2 sm:p-3 md:p-4 shadow-sm border border-gray-200">
    <div className="flex-shrink-0 mt-0.5">{icon}</div>
    <div className="flex-1 min-w-0">
      <h3 className="text-xs sm:text-sm font-semibold text-gray-900 mb-0.5">{title}</h3>
      <p className="text-xs text-gray-600">{description}</p>
    </div>
  </div>
);

export default UpgradeFeatureItem;
